const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://happyyatratravels.in/api/v1';
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1';

class ApiService {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Packages
  async getPackages(category = 'all') {
    const endpoint = category === 'all' 
      ? '/packages' 
      : `/packages?category=${category}`;
    return this.request(endpoint);
  }

  async getPackage(id) {
    return this.request(`/packages/${id}`);
  }

  // Spiritual Packages
  async getSpiritualPackages() {
    return this.request('/spiritual_packages');
  }

  async getSpiritualPackage(id) {
    return this.request(`/spiritual_packages/${id}`);
  }

  // Blog Posts
  async getBlogPosts(category = 'All') {
    const endpoint = category === 'All' 
      ? '/blog_posts' 
      : `/blog_posts?category=${category}`;
    return this.request(endpoint);
  }

  async getBlogPost(id) {
    return this.request(`/blog_posts/${id}`);
  }

  // Services
  async getServices() {
    return this.request('/services');
  }

  async getService(id) {
    return this.request(`/services/${id}`);
  }

  // Gallery
  async getGalleryItems(filter = 'all') {
    const endpoint = filter === 'all' 
      ? '/gallery_items' 
      : `/gallery_items?filter=${filter}`;
    return this.request(endpoint);
  }

  async getGalleryItem(id) {
    return this.request(`/gallery_items/${id}`);
  }

  // Banners
  async getBanners() {
    return this.request('/banners');
  }

  async getBanner(id) {
    return this.request(`/banners/${id}`);
  }

  // Reviews
  async getReviews() {
    return this.request('/reviews');
  }

  async createReview(reviewData) {
    return this.request('/reviews', {
      method: 'POST',
      body: JSON.stringify({ review: reviewData }),
    });
  }

  // Inquiries
  async createInquiry(inquiryData) {
    return this.request('/inquiries', {
      method: 'POST',
      body: JSON.stringify({ inquiry: inquiryData }),
    });
  }

  // B2B Inquiries
  async createB2bInquiry(b2bInquiryData) {
    return this.request('/b2b_inquiries', {
      method: 'POST',
      body: JSON.stringify({ b2b_inquiry: b2bInquiryData }),
    });
  }
}

export default new ApiService();
